import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { useNavigate, useOutletContext } from "react-router";
import { toast } from "react-toastify";
import axios from "axios";

import { EditProfileContainer } from "./styled";

import { FaChevronLeft } from "react-icons/fa6";

import SectionHeader from "../common/sectionTitle";
import InputField from "../common/form/inputField";
import AddressField from "../common/form/addressField";
import TelField from "../common/form/telField";

import { useModal } from "../../../../hooks/useModal";

import { resetCompany } from "../../../../store/company";
import { resetSetting } from "../../../../store/scheduler";
import { onClickLogout } from "../../../../store/user";

const areaCodes = [
  "02",
  "031",
  "032",
  "033",
  "041",
  "042",
  "043",
  "044",
  "051",
  "052",
  "053",
  "054",
  "055",
  "061",
  "062",
  "063",
  "064",
];

const EditProfile = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const isMobile = useMediaQuery({ query: "(max-width:767px)" });

  const { url, openModal, closeModal } = useOutletContext();

  const user = useSelector((state) => state?.user?.data[0]);

  const [formData, setFormData] = useState({});
  const [isDuplicate, setIsDuplicate] = useState({ moblphonNo: true, email: true });

  useEffect(() => {
    setFormData({
      name: user.name,
      username: user.userName,
      email: user.email,
      password: "",
      newPassword: "",
      passwordConfirm: "",
      // adres: "",
      // detailAdres: "",
      // tel: splitTel(user.moblphonNo),
      moblphonNo: splitTel(user.moblphonNo),
    });
  }, []);

  const changeTel = (key, field, value) => {
    setFormData((prev) => ({
      ...prev,
      [key]: {
        ...prev[key],
        [field]: onlyNumber(value),
      },
    }));

    if (isDuplicate.hasOwnProperty(key) && isDuplicate[key]) {
      setIsDuplicate((state) => ({ ...state, [key]: false }));
    }
  };

  const changeInput = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (isDuplicate.hasOwnProperty(name) && isDuplicate[name]) {
      setIsDuplicate((state) => ({ ...state, [name]: false }));
    }
  };

  // 유효성 검사
  const validateFormData = async () => {
    const fieldLabels = {
      mberNm: "고객명",
      moblphonNo: "휴대폰 번호",
      email: "이메일",
    };

    if (!formData.password) {
      toast.error("비밀번호를 입력해주세요.");
      return;
    }

    for (let key in isDuplicate) {
      if (!isDuplicate[key]) {
        const label = fieldLabels[key] || "";
        toast.error(`${label} 중복 확인을 해주세요.`);
        return;
      }
    }

    if (!formData.email) {
      toast.error("이메일을 입력해주세요.");
      return;
    }

    const regKor = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/;
    if (regKor.test(formData.email)) {
      toast.error("이메일 양식이 일치하지 않습니다.");
      return;
    }

    const isUser = await isUserVerify();
    if (isUser) {
      openModal({
        isOpen: true,
        type: "confirmation",
        title: `회원 정보 수정`,
        message: ["회원 정보를 변경하시겠습니까?"],
        handleConfirm: () => handleSubmit(),
        handleCancel: () => closeModal(),
      });
    } else {
      toast.error("로그인 정보가 일치하지 않습니다.");
    }
  };

  // 중복 검사
  const alreadyExists = async (type) => {
    const types = {
      moblphonNo: {
        isSame: joinTel(formData.moblphonNo) === user.moblphonNo,
        reg: /^01([0|1|6|7|8|9])-?([0-9]{3,4})-?([0-9]{4})$/,
        msg: "유효하지 않은 휴대폰 번호입니다.",
        url: "/api/duplMoblphonNo",
        body: { moblphonNo: joinTel(formData.moblphonNo) },
        checkDuplicate: (data) => !data.success,
        displayName: "휴대폰 번호",
      },
      email: {
        isSame: formData.email === user.email,
        reg: /([A-Za-z0-9_.-]+(\.[A-Za-z0-9_.-]+)*)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/,
        msg: "유효하지 않은 이메일 주소입니다.",
        url: "/api/duplEmail",
        body: { email: formData.email },
        checkDuplicate: (data) => !data.success,
        displayName: "이메일",
      },
    };

    const { reg, msg, isSame, url, body, checkDuplicate, displayName } = types[type];
    const inputValue = formData[type] || undefined;

    if (isSame) {
      toast.error(`기존에 사용하던 ${displayName}입니니다.`);
      setIsDuplicate((data) => ({ ...data, [type]: true }));
      return;
    }

    if (inputValue && reg.test(type === "email" ? inputValue : joinTel(inputValue))) {
      try {
        const res = await axios.post(url, body);

        if (checkDuplicate(res.data)) {
          toast.error(`이미 사용 중인 ${displayName}입니다.`);
          setIsDuplicate((data) => ({ ...data, [type]: false }));
        } else {
          toast.success(`사용 가능한 ${displayName}입니다.`);
          setIsDuplicate((data) => ({ ...data, [type]: true }));
        }
      } catch (error) {
        console.error(error);
      }
    } else {
      toast.error(msg);
    }
  };

  // 비밀번호 유효성 검사
  const checkPassword = async () => {
    if (!formData.password) {
      toast.error("기존 비밀번호를 입력해주세요.");
      return;
    }
    if (!formData.newPassword) {
      toast.error("새 비밀번호를 입력해주세요.");
      return;
    }

    const regPassword = /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[#?!@$ %^&*-]).{8,}$/;
    if (!regPassword.test(formData.newPassword)) {
      toast.error(
        "비밀번호는 영문, 숫자, 특수문자를 각각 하나 이상 포함하고 8자 이상이어야 합니다.",
      );
      return;
    }
    if (!formData.passwordConfirm) {
      toast.error("비밀번호 확인을 입력해주세요.");
      return;
    }
    if (formData.password !== formData.passwordConfirm) {
      toast.error("비밀번호가 일치하지 않습니다.");
      return;
    }

    const isUser = await isUserVerify();
    if (isUser) {
      openModal({
        isOpen: true,
        type: "confirmation",
        title: `회원 정보 수정`,
        message: [" 비밀번호를 변경하시겠습니까?"],
        handleConfirm: () => handleSubmitPassword(),
        handleCancel: () => closeModal(),
      });
    } else {
      toast.error("로그인 정보가 일치하지 않습니다.");
    }
  };

  // 전화번호 양식 수정
  const joinTel = ({ areaCode, firstPart, secondPart }) => {
    if (!areaCode || !firstPart || !secondPart) return "";
    return `${areaCode}${firstPart}${secondPart}`;
  };

  const splitTel = (tel) => {
    if (!tel) return {};

    const cleanTel = tel.replace(/-/g, "");
    const area2 = cleanTel.slice(0, 2);
    const area3 = cleanTel.slice(0, 3);

    let areaCode = "";
    let local = "";

    if (areaCodes.includes(area2)) {
      areaCode = area2;
      local = cleanTel.slice(2);
    } else if (area3 === "010") {
      areaCode = area3;
      local = cleanTel.slice(3);
    } else {
      return {};
    }

    return {
      areaCode,
      firstPart: local.slice(0, 4),
      secondPart: local.slice(4, 8),
    };
  };

  const fields = [
    {
      itemKey: "username",
      label: "아이디",
      type: "input",
      readOnly: true,
      onChange: changeInput,
    },
    {
      itemKey: "password",
      label: "현재 비밀번호",
      type: "input",
      onChange: changeInput,
    },
    {
      itemKey: "newPassword",
      label: "새 비밀번호",
      type: "input",
      onChange: changeInput,
    },
    {
      itemKey: "passwordConfirm",
      label: "비밀번호 확인",
      type: "input",
      hasButton: "비밀번호 변경",
      onChange: changeInput,
      buttonClick: checkPassword,
    },
    {
      itemKey: "name",
      label: "이름",
      type: "input",
      readOnly: true,
      onChange: changeInput,
    },
    // {
    //   itemKey: "adres",
    //   label: "주소",
    //   type: "address",
    //   adresValue: formData["adres"],
    //   detailAdresValue: formData["detailAdres"],
    //   onChange: changeInput,
    // },
    // {
    //   itemKey: "tel",
    //   label: "일반전화",
    //   type: "tel",
    //   options: areaCodes,
    //   onChange: changeInput,
    // },
    {
      itemKey: "moblphonNo",
      label: "휴대전화",
      type: "tel",
      options: ["010"],
      onChange: changeTel,
      hasButton: "중복 확인",
      buttonClick: () => alreadyExists("moblphonNo"),
    },
    {
      itemKey: "email",
      label: "이메일",
      type: "input",
      onChange: changeInput,
      hasButton: "중복 확인",
      buttonClick: () => alreadyExists("email"),
    },
  ];

  // 계정 정보 저장
  const handleSubmit = async () => {
    const apiUrl = "/api/mber";
    const body = {
      ...formData,
      username: formData.username,
      moblphonNo: joinTel(formData.moblphonNo),
      email: formData.email,
      createMberId: formData.username,
      updateMberId: formData.username,
      rgsCl: "MBRS04",
      delYn: "N",
    };

    try {
      const res = await axios.put(apiUrl, body);

      if (res.data.success) {
        toast.success("회원 정보가 수정되었습니다.", { toastId: "no-access" });
        navigate(`/shop/mypage`);
      }
    } catch (error) {
      console.log(error);
    } finally {
      closeModal();
    }
  };

  // 비밀번호 변경
  const handleSubmitPassword = async () => {
    const apiUrl = "/api/newPasswd";
    const body = {
      mberNo: user.mberNo,
      password: formData.newPassword,
      username: user.userName,
      offset: 0,
      pageNumber: 0,
      pageSize: 10,
      paged: true,
    };

    try {
      const res = await axios.post(apiUrl, body);

      if (res.data.success && res.data.message === "새로운비밀번호 변경완료") {
        toast.success("비밀번호가 변경되었습니다.");
        navigate(`/shop/mypage`);
      }
    } catch (error) {
      console.log(error);
      toast.error("잠시후 다시 시도해주세요");
    } finally {
      closeModal();
    }
  };

  const isUserVerify = async () => {
    const url = "/api/signIn";
    const body = {
      id: user.userName,
      pwd: formData.password,
    };

    const res = await axios.post(url, body);

    if (res.data.success === false) {
      toast.error("비밀번호가 일치하지 않습니다.");
      return false;
    } else {
      return true;
    }
  };

  // 회원 탈퇴
  const deleteMber = async () => {
    const apiUrl = "/api/mber";
    const body = {
      mberNo: user.mberNo,
      cmpnyNo: user.cmpnyNo,
      username: user.userName,
      mberNm: user.name,
      email: user.email,
      createMberId: user.userName,
      updateMberId: user.userName,
      delYn: "Y",
    };

    try {
      const res = await axios.put(apiUrl, body);

      if (res.data.success) {
        dispatch(onClickLogout());
        dispatch(resetSetting());
        dispatch(resetCompany());
        toast.success("회원 탈퇴가 완료되었습니다.", { toastId: "no-access" });
        navigate(`/shop/${url}/login`);
      }
    } catch (error) {
      toast.error("잠시후 다시 시도해주세요");
    } finally {
      closeModal();
    }
  };

  return (
    <>
      <EditProfileContainer>
        <h2>
          {isMobile && (
            <button onClick={() => navigate(`/shop/mypage`)}>
              <FaChevronLeft />
            </button>
          )}
          <span>회원 정보 수정</span>
        </h2>
        <SectionHeader title="기본 정보" />
        <ul>
          {fields.map((field) => {
            const { type, itemKey, ...rest } = field;

            switch (type) {
              case "input":
                return (
                  <InputField key={itemKey} itemKey={itemKey} value={formData[itemKey]} {...rest} />
                );
              // case "address":
              //   return (
              //     <AddressField
              //       key={itemKey}
              //       {...rest}
              //       adresValue={formData["adres"]}
              //       detailAdresValue={formData["detailAdres"]}
              //     />
              //   );
              case "tel":
                return (
                  <TelField key={itemKey} itemKey={itemKey} value={formData[itemKey]} {...rest} />
                );
              default:
                return null;
            }
          })}
        </ul>
        <div className="submit">
          <div>
            <button onClick={validateFormData}>회원 정보 수정</button>
          </div>
          <button
            onClick={() =>
              openModal({
                isOpen: true,
                type: "confirmation",
                title: `회원 탈퇴`,
                message: [
                  "탈퇴 시 모든 데이터가 영구 삭제되며 복구할 수 없습니다.",
                  "회원 탈퇴를 진행하시겠습니까?",
                ],
                handleConfirm: () => deleteMber(),
                handleCancel: () => closeModal(),
              })
            }>
            회원탈퇴
          </button>
        </div>
      </EditProfileContainer>
    </>
  );
};

export default EditProfile;
